import React from 'react';
import PropTypes from 'prop-types';

const IconLock2 = ({ color = '#fff', ...props }) => (
    <svg width={13} height={16} {...props}>
      <path
        d="M8.92 5.333v-1.17A2.383 2.383 0 006.539 1.78h-.155A2.383 2.383 0 004 4.163v1.168c-.598.048-1.194.112-1.789.192V4.162A4.169 4.169 0 016.391 0h.155a4.169 4.169 0 014.164 4.163v1.362a30.542 30.542 0 00-1.79-.192zM.939 7.205a29.751 29.751 0 0111.064 0c.49.093.844.523.84 1.021v6.278a.933.933 0 01-.757.916l-.567.107c-3.336.631-6.76.631-10.097 0l-.57-.107a.933.933 0 01-.76-.916V8.133a.934.934 0 01.76-.916l.087-.012zm4.487 5.859a2.87 2.87 0 002.086 0 .231.231 0 00.135-.298l-.543-1.532a1.021 1.021 0 10-1.268 0l-.543 1.532a.231.231 0 00.133.298z"
        fill={color}
        fillRule="nonzero"
      />
    </svg>
  );

IconLock2.propTypes = {
  color: PropTypes.string,
};

export default IconLock2;
